var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E8F7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5001 16.0001C26.7234 16.8299 24.3895 17.3334 21.8334 17.3334C20.4122 17.3334 18.5001 17.3334 15.1667 16.0001V34.6667C18.5001 36.0001 20.4122 36.0001 21.8334 36.0001C24.3895 36.0001 26.7234 35.4966 28.5001 34.6667C30.2767 33.8369 32.6106 33.3334 35.1667 33.3334C39.1667 33.3334 41.8334 34.6667 41.8334 34.6667V16.0001C41.8334 16.0001 39.1667 14.6667 35.1667 14.6667C32.6106 14.6667 30.2767 15.1703 28.5001 16.0001Z",
    stroke: "#21ADE3",
    strokeWidth: 2.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 38.6666C16.9435 39.4965 19.2773 39.9999 21.8334 39.9999C24.3895 39.9999 26.7234 39.4965 28.5001 38.6666C30.2767 37.8367 32.6106 37.3333 35.1667 37.3333C37.7229 37.3333 40.0567 37.8367 41.8334 38.6666",
    stroke: "#21ADE3",
    strokeWidth: 2.66667,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7683 25.3333C31.7683 27.1743 30.2759 28.6667 28.4349 28.6667C26.594 28.6667 25.1016 27.1743 25.1016 25.3333C25.1016 23.4924 26.594 22 28.4349 22C30.2759 22 31.7683 23.4924 31.7683 25.3333Z",
    stroke: "#21ADE3",
    strokeWidth: 2.66667,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 26.6667V26.6787",
    stroke: "#21ADE3",
    strokeWidth: 2.66667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1667 23.988V24",
    stroke: "#21ADE3",
    strokeWidth: 2.66667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW);
export default __webpack_public_path__ + "static/media/w.cca41cc049932bb2ed36f163f6eedc02.svg";
export { ForwardRef as ReactComponent };